import MoreInfoIcon from './MoreInfoIcon';

export default MoreInfoIcon;
